export default __webpack_public_path__ + "static/media/unity-upi.20c62a63.svg";